export default{
    actions: {
      
    },
    mutations: {
    addpodatgorod(state, newpost){
        state.gorod=newpost;
    },
    addpodatgorod_text(state, newpost){
        state.gorod_text=newpost;
    },
    addpodatkateg(state, newpost){
        state.kateg=newpost;
    },
    addpodatkateg_text(state, newpost){
        state.kateg_text=newpost;
    },
    addpodatpodkateg(state, newpost){
        state.podkateg=newpost;
    },
    addpodatpodkateg_text(state, newpost){
        state.podkateg_text=newpost;
    },
    addpodatmarka(state, newpost){
        state.marka=newpost;
    },
    addpodatmarka_text(state, newpost){
        state.marka_text=newpost;
    },
    addpodatmodel(state, newpost){
        state.model=newpost;
    },
    addpodatmodel_text(state, newpost){
        state.model_text=newpost;
    },
    addpodatgod(state, newpost){
        state.god=newpost;
    },
    addpodatkuzov(state, newpost){
        state.kuzov=newpost;
    },
    addpodatkuzov_text(state, newpost){
        state.kuzov_text=newpost;
    },
    addpodatcolor(state, newpost){
        state.color=newpost;
    },
    addpodatcolor_text(state, newpost){
        state.color_text=newpost;
    },
    addpodattopliva(state, newpost){
        state.topliva=newpost;
    },
    addpodattopliva_text(state, newpost){
        state.topliva_text=newpost;
    },
    addpodatkarobka(state, newpost){
        state.karobka=newpost;
    },
    addpodatkarobka_text(state, newpost){
        state.karobka_text=newpost;
    },
    addpodatprivod(state, newpost){
        state.privod=newpost;
    },
    addpodatprivod_text(state, newpost){
        state.privod_text=newpost;
    },
    addpodattip(state, newpost){
        state.tip=newpost;
    },
    addpodattip_text(state, newpost){
        state.tip_text=newpost;
    },
    addpodatkompleckt(state, newpost){
        state.kompleckt=newpost;
    },
    addpodatkompleckt_text(state, newpost){
        state.kompleckt_text=newpost;
    },
    addpodatobdvigatel(state, newpost){
        state.obdvigatel=newpost;
    },
    addpodatsena(state, newpost){
        state.sena=newpost;
    },
    addpodatbody(state, newpost){
        state.body=newpost;
    },
    addpodatprobeg(state, newpost){
        state.probeg=newpost;
    },
    addpodattorg(state, newpost){
        state.torg=newpost;
    },
    addpodatgosnomer(state, newpost){
        state.gosnomer=newpost;
    },
    addpodatzagolovok(state, newpost){
        state.zagolovok=newpost;
    },
    addpodatopsiya(state, newpost){
        state.opsiya=newpost;
    },
    addpodattipshina(state, newpost){
        state.tipshina=newpost;
    },
    addpodatprofil(state, newpost){
        state.profil=newpost;
    },
    addpodatdiametr(state, newpost){
        state.diametr=newpost;
    },
    addpodatshirina(state, newpost){
        state.shirina=newpost;
    },
    addpodattipdiski(state, newpost){
        state.tipdiski=newpost;
    },
    addpodatpcd(state, newpost){
        state.pcd=newpost;
    },
    addpodatsostoyanie(state, newpost){
        state.sostoyanie=newpost;
    },
    addpodatfoto(state, newpost){
        state.foto=newpost;
    },
    addpodatchat(state, newpost){
        state.chat=newpost;
    },
    addpodatwhatsapp(state, newpost){
        state.whatsapp=newpost;
    },
    addpodatid(state, newpost){
        state.id=newpost;
    },
    addpodatobmen(state, newpost){
        state.obmen=newpost;
    },
    addpodatobmentext(state, newpost){
        state.obmen_text=newpost;
    },
    },
    state: {
        id:"",
        gorod:"",
        gorod_text:"",
        kateg:"",
        kateg_text:"",
        podkateg:"",
        podkateg_text:"",
        marka:"",
        marka_text:"",
        model:"",
        model_text:"",
        god:"",
        kuzov:"",
        kuzov_text:"",
        color:"",
        color_text:"",
        topliva:"",
        topliva_text:"",
        karobka:"",
        karobka_text:"",
        privod:"",
        privod_text:"",
        obdvigatel:"",
        sena:"",
        body:"",
        probeg:"",
        torg:false,
        gosnomer:false,
        zagolovok:"",
        opsiya:[],
        foto:[],
        tip:"",
        tip_text:"",
        kompleckt:"",
        kompleckt_text:"",
        tipshina:"",
        tipdiski:"",
        profil:"",
        diametr:"",
        shirina:"",
        pcd:"",
        sostoyanie:"bu",
        chat:"",
        whatsapp:"",
        obmen:"",
        obmen_text:""

    },
    getters:{
        getpodatgorod(state){
            return state.gorod
        },
        getpodatgorod_text(state){
            return state.gorod_text
        }, 
        getpodatkateg(state){
            return state.kateg
        },
        getpodatkateg_text(state){
            return state.kateg_text
        },
        getpodatpodkateg(state){
            return state.podkateg
        },
        getpodatpodkateg_text(state){
            return state.podkateg_text
        },
        getpodatmarka(state){
            return state.marka
        },
        getpodatmarka_text(state){
            return state.marka_text
        },
        getpodatmodel(state){
            return state.model
        },
        getpodatmodel_text(state){
            return state.model_text
        },
        getpodatgod(state){
            return state.god
        },
        getpodatkuzov(state){
            return state.kuzov
        },
        getpodatkuzov_text(state){
            return state.kuzov_text
        },
        getpodatcolor(state){
            return state.color
        },
        getpodatcolor_text(state){
            return state.color_text
        },
        getpodattopliva(state){
            return state.topliva
        },
        getpodattopliva_text(state){
            return state.topliva_text
        },
        getpodatkarobka(state){
            return state.karobka
        },
        getpodatkarobka_text(state){
            return state.karobka_text
        },
        getpodatprivod(state){
            return state.privod
        },
        getpodatprivod_text(state){
            return state.privod_text
        },
        getpodattip(state){
            return state.tip
        },
        getpodattip_text(state){
            return state.tip_text
        },
        getpodatkompleckt(state){
            return state.kompleckt
        },
        getpodatkompleckt_text(state){
            return state.kompleckt_text
        },
        getpodatobdvigatel(state){
            return state.obdvigatel
        },
        getpodatsena(state){
            return state.sena
        },
        getpodatbody(state){
            return state.body
        },
        getpodatprobeg(state){
            return state.probeg
        },
        getpodattorg(state){
            return state.torg
        },
        getpodatgosnomer(state){
            return state.gosnomer
        },
        getpodatopsiya(state){
            return state.opsiya
        },
        getpodatzagolovok(state){
            return state.zagolovok
        },
        getpodattipshina(state){
            return state.tipshina
        },
        getpodattipdiski(state){
            return state.tipdiski
        },
        getpodatprofil(state){
            return state.profil
        },
        getpodatdiametr(state){
            return state.diametr
        },
        getpodatshirina(state){
            return state.shirina
        },
        getpodatpcd(state){
            return state.pcd
        },
        getpodatsostoyanie(state){
            return state.sostoyanie
        },
        getpodatfoto(state){
            return state.foto
        },
        getpodatchat(state){
            return state.chat
        },
        getpodatwhatsapp(state){
            return state.whatsapp
        },
        getpodatid(state){
            return state.id
        },
        getpodatobmen(state){
            return state.obmen
        },
        getpodatobmentext(state){
            return state.obmen_text
        },
    }
}